var exports = {
  "Sw": "GuildFolderItem.module__folderContainer___cTN3eE",
  "V8": "GuildFolderItem.module__relative___cTN3eE",
  "o6": "GuildFolderItem.module__collapsedFolder___cTN3eE",
  "yx": "GuildFolderItem.module__collapsedFolderBackground___cTN3eE",
  "sD": "GuildFolderItem.module__miniGuildIcon___cTN3eE",
  "jD": "GuildFolderItem.module__miniGuildIconWithInitials___cTN3eE",
  "Q5": "GuildFolderItem.module__miniGuildInitials___cTN3eE",
  "mw": "GuildFolderItem.module__folderBadge___cTN3eE",
  "M8": "GuildFolderItem.module__folderBadgeActive___cTN3eE",
  "k9": "GuildFolderItem.module__expandedFolderBackground___cTN3eE",
  "MJ": "GuildFolderItem.module__folderHeader___cTN3eE",
  "mK": "GuildFolderItem.module__folderHeaderButton___cTN3eE",
  "Eh": "GuildFolderItem.module__folderIcon___cTN3eE",
  "QD": "GuildFolderItem.module__expandedGuilds___cTN3eE",
  "h5": "GuildFolderItem.module__folderTooltipContainer___cTN3eE",
  "bO": "GuildFolderItem.module__folderTooltipName___cTN3eE",
  "Il": "GuildFolderItem.module__dropIndicatorTop___cTN3eE",
  "Yc": "GuildFolderItem.module__dropIndicatorBottom___cTN3eE",
  "Zg": "GuildFolderItem.module__dropIndicatorInside___cTN3eE",
};

module.exports = exports;
